import BaseService from "./BaseService";

export default class TimeLineService extends BaseService {

  constructor(self) {
    super(self);
  }

  ListarEventos(parameters) {
    return this.ExecutaFetch("/api/TimeLine/ListarEventos", "POST", parameters);
  }
}